export default __webpack_public_path__ + "fca62feac0e5a8356fa4a143e93b7b18.svg";